module.exports = (function (e) {
  var t = {};
  function r(n) {
    if (t[n]) return t[n].exports;
    var o = (t[n] = { i: n, l: !1, exports: {} });
    return e[n].call(o.exports, o, o.exports, r), (o.l = !0), o.exports;
  }
  return (
    (r.m = e),
    (r.c = t),
    (r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n });
    }),
    (r.r = function (e) {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(e, '__esModule', { value: !0 });
    }),
    (r.t = function (e, t) {
      if ((1 & t && (e = r(e)), 8 & t)) return e;
      if (4 & t && 'object' == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (
        (r.r(n),
        Object.defineProperty(n, 'default', { enumerable: !0, value: e }),
        2 & t && 'string' != typeof e)
      )
        for (var o in e)
          r.d(
            n,
            o,
            function (t) {
              return e[t];
            }.bind(null, o),
          );
      return n;
    }),
    (r.n = function (e) {
      var t =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return r.d(t, 'a', t), t;
    }),
    (r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (r.p = ''),
    r((r.s = 2))
  );
})([
  function (e, t, r) {
    e.exports = r(3)();
  },
  function (e, t) {
    e.exports = require('react');
  },
  function (e, t, r) {
    'use strict';
    r.r(t);
    var n = r(1),
      o = r.n(n),
      a = r(0),
      i = r.n(a),
      u = function (e) {
        var t = e.onClick,
          r = void 0 === t ? function () {} : t,
          n = e.disabled,
          a = void 0 !== n && n,
          i = e.addClass,
          u = void 0 === i ? '' : i,
          c = e.value,
          s = void 0 === c ? '' : c,
          l = e.type,
          p = void 0 === l ? 'button' : l,
          f = e.children,
          d = e.ariaLabel,
          b = void 0 === d ? '' : d;
        return o.a.createElement(
          'button',
          {
            className: 'ra-button '.concat(u),
            onClick: r,
            disabled: a,
            value: s,
            type: p,
            'aria-label': b,
          },
          f,
        );
      };
    (u.propTypes = {
      onClick: i.a.func.isRequired,
      addClass: i.a.string,
      disabled: i.a.bool,
      value: i.a.string.isRequired,
      type: i.a.oneOf(['submit', 'reset', 'button']).isRequired,
      children: i.a.oneOfType([i.a.array, i.a.object]),
      ariaLabel: i.a.string,
    }),
      (t.default = u);
  },
  function (e, t, r) {
    'use strict';
    var n = r(4);
    function o() {}
    function a() {}
    (a.resetWarningCache = o),
      (e.exports = function () {
        function e(e, t, r, o, a, i) {
          if (i !== n) {
            var u = new Error(
              'Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types',
            );
            throw ((u.name = 'Invariant Violation'), u);
          }
        }
        function t() {
          return e;
        }
        e.isRequired = e;
        var r = {
          array: e,
          bool: e,
          func: e,
          number: e,
          object: e,
          string: e,
          symbol: e,
          any: e,
          arrayOf: t,
          element: e,
          elementType: e,
          instanceOf: t,
          node: e,
          objectOf: t,
          oneOf: t,
          oneOfType: t,
          shape: t,
          exact: t,
          checkPropTypes: a,
          resetWarningCache: o,
        };
        return (r.PropTypes = r), r;
      });
  },
  function (e, t, r) {
    'use strict';
    e.exports = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  },
]);
